<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 16:49:00
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-16 20:19:16
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/map-dttj2.vue
 * @Description: 描述
-->
<template>
  <div class="dttj2" v-loading="loading.dttj">
    <template v-if="!loading.dttj">
      <div class="item" v-for="(item, index) in dttj" :key="index">
        <i class="arrow" />
        <div class="name">{{ item.name + "(" + item.unit + ")" }}</div>
        <div class="value" v-if="item.value === 0">{{ item.value }}</div>
        <ICountUp class="value" v-else :endVal="Number(item.value)" />
        <i class="divider" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('production-management', ['dttj', 'loading'])
  },
  methods: {
    ...mapActions('production-management', ['getDTTJ'])
  },
  created () {
    this.getDTTJ()
  }
}
</script>

<style lang="scss">
.dttj2 {
  width: 234px;
  height: 432px;
  .item {
    position: relative;
    height: 86px;
    margin-bottom: 30px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .arrow {
      position: absolute;
      left: 0;
      top: 4px;
      // width: 14px;
      // height: 26px;
      // background: #10f5b1;
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-right: 14px solid transparent;
      border-bottom: 13px solid transparent;
      border-left: 14px solid #10f5b1;
    }
    .name {
      position: absolute;
      right: 0;
      width: 212px;
      height: 34px;
      line-height: 34px;
      background: #376766;
      padding-left: 24px;
      padding-left: 12px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
    .value {
      position: absolute;
      top: 44px;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-family: Bahnschrift;
      font-weight: 600;
      color: #ffffff;
    }
    .divider {
      position: absolute;
      top: 86px;
      left: 0;
      width: 100%;
      height: 2px;
      background-position: center;
      background-image: url("/public/image/production-management/icon/下划线@2x.png");
    }
  }
}
</style>
